<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="400"
  >
      <v-card>
        <v-system-bar
          color="primary"
          dark
        ><span class="white--text">Перемещение сотрудника </span></v-system-bar>
        <v-card-text>
            <v-alert
              dense
              icon="mdi-folder"
              border="left"
              colored-border
              color="amber darken-1"
              type="info"
              elevation="2"
              class="mt-2"
            >
              {{ user ? user.ITP_NAME : '' }}
          </v-alert>
          <v-row>
            <v-col cols="12">
              <org-division-select
                v-model="divisionID"
                :org="org"
                :label="'Целевое подразделение'"
                :filter="divFilter"
              ></org-division-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="$emit('input', false)"
          >Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="moveDisabled"
            @click="doMoveEmploee"
          >Переместить</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { ORG_MOVE_EMPLOEE } from '@/store/actions/org'
import { UI_SNACKBAR } from '@/store/actions/ui'
import OrgDivisionSelect from '@/components/modules/org/clients/components/orgDivisionSelect'
export default {
  name: 'moveEmployeeDialog',
  props: ['value', 'org', 'user'],
  components: {
    OrgDivisionSelect
  },
  data () {
    return {
      divisionID: null
    }
  },
  computed: {
    moveDisabled: {
      get: function () {
        if (!this.user) {
          return true
        }
        return this.user.ITP_ID === this.divisionID
      }
    }
  },
  watch: {
    user (val) {
      if (val) {
        this.divisionID = val.ITP_ID
      } else {
        this.divisionID = null
      }
    },
    org (val) {
      if (!val) {
        this.$emit('input', false)
      }
    }
  },
  methods: {
    divFilter (item) {
      if (!this.user) return false
      return item.IS_STATE !== '1' && item.IS_STATE !== '-1' && item.ITP_ID !== this.user.ITP_ID
    },
    doMoveEmploee () {
      const params = {
        INST_UUID: this.org.INST_UUID,
        ITP_ID: this.divisionID,
        EMP_ID: this.user.EMP_ID
      }
      this.$store.dispatch(ORG_MOVE_EMPLOEE, params)
        .then((resp) => {
          this.$emit('onEmploeeMoved', resp)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка изменения данных ' + err })
          console.log('Ошибка перемещения сотрудника ', err)
        })
      this.$emit('input', false)
    }
  },
  mounted () {
    console.log('moveEmployeeDialog mounted. Org is ', this.org, 'User is ', this.user)
  }
}
</script>
